<template>
  <div class="informationDisclosure">
    <z-fix-top ref="fixtop" keep-position class="fixtop" :style="{ background: '#F7F7F7' }">
      <z-nav-bar class="navbar" left-arrow :title="navTitle">
      </z-nav-bar>
    </z-fix-top>
    <z-loading v-if="loading" type="zz" size="60px" vertical class="message">正在加载</z-loading>
  </div>
</template>

<script>
import { NavBar, FixTop, Loading, Toast } from '@zz-common/zz-ui';
import { queryParams, getCookie } from '@lib/utils'
import { lego } from '@zz-common/lego'
import { getCaseTrackStatusByOrderId } from '@api/resourceApi'
import native from '@zz-common/native-adapter';

const query = queryParams()

export default {
  name: 'ReportReason',
  data() {
    return {
      navTitle: '监督举报',
      evidenceCount: 0,
      reportSource: query.reportSource || this.$route.query.reportSource,
      appointmentId: query.appointmentId || this.$route.query.appointmentId,
      orderId: query.orderId || this.$route.query.orderId,
      status: 0,
      loading: true
    }
  },
  components: {
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    'z-loading': Loading
  },
  methods: {
    async init() {
      if (!this.orderId) {
        Toast('订单id不存在')
        setTimeout(() => {
          native.close()
        }, 1000)
        return
      }
      const params = {
        reportSource: this.reportSource,
        orderId: this.orderId
      }
      lego.send({
        pagetype: 'SUPERVISE',
        actiontype: 'ENTRY_INIT_PAGE',
        backup: {
          uid: getCookie('uid')
        }
      })
      const statusRes = await getCaseTrackStatusByOrderId(params)
      const { historyId } = statusRes;
      if (historyId) {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/supervise/result?orderId=${this.orderId}&reportSource=${this.reportSource}${this.appointmentId ? `&appointmentId=${this.appointmentId}` : ''}`,
          needClose: 1
        })
        return
      }
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/supervise/entry?orderId=${this.orderId}&reportSource=${this.reportSource}${this.appointmentId ? `&appointmentId=${this.appointmentId}` : ''}`,
        needClose: 1
      })
    }
  },
  created() {
    this.init()
  }
}
</script>

<style scoped lang="less">
@import 'index.less';
</style>
